import React, { ReactNode } from 'react';
import './index.css';

interface AuthContainerProps {
  children: ReactNode;
  className?: string;
}

const AuthContainer: React.FC<AuthContainerProps> = ({ children, className = '' }) => {
  return (
    <div
      className={`flex items-center justify-center min-h-screen font-sans auth-background px-4 md:px-8 lg:px-[110px] py-8 md:py-12 lg:py-[4rem] ${className}`}
    >
      <div className="w-full h-full overflow-y-auto no-scrollbar">
        <div className="flex flex-col lg:flex-row w-full rounded-2xl min-h-[85vh] bg-white font-poppins shadow-md">
          
          {/* Left side - background image (only on md and above) */}
          <div
            className="hidden lg:block lg:w-1/2 bg-[#D9D9D9] rounded-t-2xl lg:rounded-l-2xl lg:rounded-r-none"
            style={{
              backgroundImage: 'url(/images/bg.png)',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />

          {/* Right side - children content */}
          <div className="w-full lg:w-1/2 p-6 sm:p-8 md:p-10">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthContainer;
